/* eslint-disable react/display-name */
//todo modificare il ruolo con uelli veri
import React from 'react';
import { theme } from 'theme';
export const Roles = {
  BRAND: 'Brand',
  USER: 'User',
  ADMIN: 'Admin',
  OPERATOR: 'Operator',
};

export const purposesEnum = {
  INVITE: 'pageInvite',
  DELETE: 'pageDeleteBr',
  REMOVE: 'pageCancelUser',
};

export const maxInvitations =
  parseInt(process.env.REACT_APP_MAX_INVITATIONS) || 49;

export const maxChatInvitations =
  parseInt(process.env.REACT_APP_MAX_INVITATIONS_CHAT) || 2000;

export const delayForCreation =
  parseInt(process.env.REACT_APP_DAYS_DELAY_FOR_CREATION) || 0;

export const defaultLang = process.env.REACT_APP_DEFAULT_LANG || 'it';

export const filterLink =
  process.env.REACT_APP_FILTER_ENV_PATH ||
  'https://sdmveprdwemktdbdatalake.dfs.core.windows.net/drupal/catalog/SDM-Catalogo-Filters.json?sv=2020-02-10&ss=b&srt=co&sp=r&se=2999-07-05T15:50:15Z&st=2021-07-05T05:50:15Z&spr=https&sig=7NdSKC3YAG0rSCAfTPdefJWv4Ze1Gj6bSIzoVjsC6%2FU%3D';

export const defaultSearchYear =
  process.env.REACT_APP_DEFAULT_SEARCH_YEAR || '2025';

export const discountCodeId = process.env.REACT_APP_DISCOUNT_CODE_ID || 'PRD_';

export const isDiscountTicket = (ticket) =>
  ticket.code?.includes(discountCodeId);

export const discountCodeStatus = {
  CODE_EXPIRED: 'codeExpired',
  CODE_NOT_FOUND: 'codeNotFound',
  CODE_UPDATED: 'codeUpdated',
  CODE_VALID: 'codeValid',
};

export const languagesOptions = ['it', 'en'];

export const cdnUrl =
  process.env.REACT_APP_CDN_URL || 'https://d2p7oj81vnytpt.cloudfront.net';

export const launchDate =
  process.env.REACT_APP_LAUNCH_DATE || '2021-06-24T00:00:00.000Z';

export const deadlineEditTicket =
  process.env.REACT_APP_DEADLINE_TICKET_EDIT || '2025-04-07T22:00:00.000Z';

export const isBookingBrandActive =
  process.env.REACT_APP_IS_BOOKING_BRAND_ACTIVE === 'true' || false;

export const isMapBrandActive =
  process.env.REACT_APP_IS_MAP_BRAND_ACTIVE === 'true' || false;

export const isTicketingActive =
  process.env.REACT_APP_IS_TICKETING_ACTIVE === 'true' || true;

export const isQueryFiltersActive =
  process.env.REACT_APP_QUERY_FILTERS_ACTIVE === 'true' || false;

export const isPostEvent =
  process.env.REACT_APP_IS_POST_EVENT === 'true' || false;

export const userDummyPrd = process.env.REACT_APP_DUMMY_PRD || false;

export const ENV = process.env.REACT_APP_USER_BRANCH || 'dev';

export const awsSecretAccessKey = process.env.SECRET_ACCESS_KEY;
export const awsAccessKeyId = process.env.ACCESS_KEY_ID;
export const breakoutRoomLink = process.env.REACT_APP_BREAKOUTROOM_LINK;
export const backHomeLink =
  process.env.REACT_APP_BR_BACK_REDIRECT ||
  'https://b0a2-93-41-34-245.ngrok-free.app';

export const charactersCount =
  process.env.REACT_APP_EXHIBITOR_SEARCH_CHAR_COUNT || 1;

export const JsonApiEditorlocalClientId =
  'e30b2a11-1c5a-48b4-acc7-60bac4772fac';
export const JsonApiEditorlocalClientSecret = '1';
export const JsonApiEditorlocalUsername = 'pier';
export const JsonApiEditorlocalPassword = '1234';

export const PUBNUB_PUBLISH_KEY =
  process.env.REACT_APP_PUBNUB_PUBLISH_KEY ||
  'pub-c-4757bb4a-4333-4e9e-b035-15effcaa1353';
export const PUBNUB_SUBSCRIBE_KEY =
  process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY ||
  'sub-c-d9d965fc-2da7-11eb-9d95-7ab25c099cb1';

export const isUnbanEnabled = process.env.IS_UNBAN_ENABLED === 'true' || true;

export const cartWithDummies = false;
// process.env.REACT_APP_CART_WITH_DUMMIES === 'true' || false;

export const allowedModeratorEmail =
  process.env.REACT_APP_LIVE_CHAT_MODERATOR_EMAIL || 'chiara.cini@nautes.com';

export const stripePubKey =
  process.env.REACT_APP_STRIPE_PUB_KEY || 'pk_test_5pVE2vr8vfuQZ4xZ5AFTSXWc';

export const routes = {
  agenda: {
    salesTeam: '/sales-team',
    agenda: '/virtual-agenda',
    booking: '/booking-request',
  },
};

export const slotStatus = {
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
  CHECKED: 'checked',
};

export const slotContext = {
  SLOT: 'slot',
  REQUEST: 'request',
};

export const AgendaVisitStartHour = '09:30';
export const AgendaVisitEndHour = '18:30';
export const SaloneStartDate =
  process.env.REACT_APP_SALONE_START_DATE || '2025-04-07T22:00:00.000Z';
export const SaloneEndDate =
  process.env.REACT_APP_SALONE_END_DATE || '2025-04-12T22:00:00.000Z';

export const htmlParserOptions = {
  div: (children) => <div style={{ marginBottom: 0 }}>{children}</div>,
  p: (str) => <p>{str}</p>,
  ul: (str) => <ul>{str}</ul>,
  li: (str) => <li>{str}</li>,
  strong: (str) => <strong>{str}</strong>,
  em: (str) => <em>{str}</em>,
  h3: (str) => <h3>{str}</h3>,
  br: () => <br />,
  i: (str) => <i>{str}</i>,
  uppercase: (str) => <p style={{ textTransform: 'uppercase' }}>{str}</p>,
  underline: (str) => (
    <span style={{ textDecoration: 'underline' }}>{str}</span>
  ),
  upperline: (str) => (
    <p style={{ textDecoration: 'underline', textTransform: 'uppercase' }}>
      {str}
    </p>
  ),
  spaced: (children) => <div style={{ marginBottom: 10 }}>{children}</div>,
  privacy: (str) => (
    <a
      href={`https://www.salonemilano.it/${
        window?.location?.pathname?.split('/')?.[1] &&
        window.location.pathname.split('/')[1].length === 2
          ? window.location.pathname.split('/')[1]
          : defaultLang
      }/privacy-policy`}
      target="_blank"
      rel="noreferrer"
      style={{ fontWeight: 'bold', color: theme.colors.primary.red }}
    >
      {str}
    </a>
  ),
  info: (str) => (
    <a
      href={`mailto:${str}`}
      target="_blank"
      rel="noreferrer"
      style={{ fontWeight: 'bold', color: theme.colors.primary.red }}
    >
      {str}
    </a>
  ),
  link: (str) => (
    <a
      href={`https://www.youtube.com/watch?v=Gx8ES3X1CtQ&t=1s`}
      target="_blank"
      rel="noreferrer"
      style={{ fontWeight: 'bold', color: theme.colors.primary.red }}
    >
      {str}
    </a>
  ),
  linkeng: (str) => (
    <a
      href={`https://www.youtube.com/watch?v=z9aGzIk4mCU`}
      target="_blank"
      rel="noreferrer"
      style={{ fontWeight: 'bold', color: theme.colors.primary.red }}
    >
      {str}
    </a>
  ),
};
